import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import {
  resetMinMeetingDurationsForm,
  updateShowSetMinConDurationsForm,
  updateShowSetMinMeetingDurationsForm,
} from '../../../../actions/report';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);
export default function CenterPanelSetMinDurations(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    resetForm();
  }, []);
  // If input is not a number with less than 1 decimal place,
  // cannot enter
  const minConsultationDurChanged = (value) => {
    let regex = new RegExp(/^[0-9]{0,2}(\.[0-9]{0,1})?$/);
    if (regex.test(value)) {
      dispatch(updateShowSetMinConDurationsForm(value));
    }
  };

  const minMeetingDurChanged = (value) => {
    let regex = new RegExp(/^[0-9]{0,2}(\.[0-9]{0,1})?$/);
    if (regex.test(value)) {
      dispatch(updateShowSetMinMeetingDurationsForm(value));
    }
  };

  // reset form to default values - (0 / values stored in state)
  const resetForm = () => {
    let minConsultationDurInState =
      window.localStorage && window.localStorage.getItem(`minConsultationDur-${props.userId}`)
        ? parseInt(window.localStorage.getItem(`minConsultationDur-${props.userId}`), 10)
        : null;
    let minMeetingDurValueInState =
      window.localStorage && window.localStorage.getItem(`minMeetingDur-${props.userId}`)
        ? parseInt(window.localStorage.getItem(`minMeetingDur-${props.userId}`), 10)
        : null;
    dispatch(resetMinMeetingDurationsForm(minConsultationDurInState, minMeetingDurValueInState));
  };

  return (
    <div className="ui form mrbm">
      <div className="title-sms mrbm">
        {htmlToReactParser.parse(
          xss(
            APP.LANGUAGE.UpdateMinDurations.SubTitle.replace(
              '##platformName##',
              window.APP.CONFIGURATION.PORTAL.VideoCallPlatformName
            )
          )
        )}
      </div>
      <div className="mrbm" />
      <div>
        <label className="title-sms">{APP.LANGUAGE.UpdateMinDurations.MinConsultationPlaceholder}</label>
      </div>
      <div className="duration-row">
        <div className="shorter-column">
          <Txt
            number
            tabIndex="1"
            value={props.typingMinConDurationValue}
            focusme="true"
            maxLength={4}
            placeholder={parseFloat(0).toFixed(1)}
            allowDecimal={true}
            onChange={minConsultationDurChanged}
            notRenderPlaceholderAsTitle={true}
          />
        </div>
        <div className="inline-wrap pdlxs">
          <div>minutes</div>
        </div>
      </div>
      <div className="mrbm" />
      <div>
        <label className="title-sms">{APP.LANGUAGE.UpdateMinDurations.MinMeetingPlaceholder}</label>
      </div>
      <div className="duration-row">
        <div className="shorter-column">
          <Txt
            number
            tabIndex="2"
            value={props.typingMinMeetingDurationValue}
            allowDecimal={true}
            maxLength={4}
            placeholder={parseFloat(0).toFixed(1)}
            onChange={minMeetingDurChanged}
            notRenderPlaceholderAsTitle={true}
          />
        </div>
        <div className="inline-wrap pdlxs">
          <div>minutes</div>
        </div>
      </div>
    </div>
  );
}
